//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductDetails',
  props: {
    descriptionHtml: {
      type: String,
      default: null
    },
    lineName: {
      type: String,
      default: null
    },
    lineUrl: {
      type: String,
      default: null
    },
    lineHtml: {
      type: String,
      default: null
    }
  }
};